// extracted by mini-css-extract-plugin
export var productImage = "_wa-0";